import "./closest";
function checkIsIE() {
    if (typeof window !== "undefined" && window) {
        var msie = window.navigator.userAgent.indexOf("MSIE ");
        return !!(msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./));
    }
    return false;
}
if (checkIsIE()) {
    var polyfills = ["es2015-core", "es2016-array-include", "es2017-string", "es2017-object"];
    polyfills.forEach(function (p) { return import(/* webpackChunkName: "ts-polyfill/[request]"*/ "ts-polyfill/lib/" + p); });
    console.warn("Init IE Polyfills");
    import(/* webpackChunkName: "smartdesign/polyfills/css-vars-ponyfill" */ "css-vars-ponyfill").then(function (module) {
        module.default({ onlyLegacy: true });
    });
}
